import { Injectable, } from '@angular/core';
import { AppointmentDto } from '@core/interfaces/api.interfaces';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogConfirmComponent, DialogConfirmModel } from '@core/components/components/dialog-confirm/dialog-confirm';
import { MatDialog } from '@angular/material/dialog';
import { DialogQuestionSimpleComponent, DialogQuestionSimpleModel } from '@core/components/components/dialog-question-simple/dialog-question-simple';
import { DialogQuestionComponent, DialogQuestionModel } from '@core/components/components/dialog-question/dialog-question';

@Injectable(
    {
        providedIn: 'root'
    }
)

export class ToastService {

    constructor(
        private _snackBar: MatSnackBar,
        public dialog: MatDialog,
    ) { }

    notification(title: string, message: string, complete?: () => void, cancel?: () => void) {
        const dialogData = new DialogConfirmModel(title, message);
        const dialogRef = this.dialog.open(DialogConfirmComponent, {
            data: dialogData
        });
        dialogRef.afterClosed().subscribe(dialogResult => {
            if (dialogResult) {
                if (!!complete && typeof complete === 'function') {
                    complete();
                }
            } else {
                if (!!cancel && typeof cancel === 'function') {
                    cancel();
                }
            }
        });
    }

    question(title: string, message: string, complete?: (reason: string) => void, cancel?: () => void) {
        let theReason = '';
        const dialogData = new DialogQuestionModel(title, message);
        const dialogRef = this.dialog.open(DialogQuestionComponent, {
            data: dialogData
        });

        // Need to capture the value BEFORE the dialog closes
        dialogRef.beforeClosed().subscribe(_dialogResult => {
            const el = <any>document.getElementById('izitoast--input');
            theReason = el.value;
        });

        dialogRef.afterClosed().subscribe(dialogResult => {
            if (dialogResult) {
                if (!!complete && typeof complete === 'function') {
                    complete(theReason);
                }
            } else {
                if (!!cancel && typeof cancel === 'function') {
                    cancel();
                }
            }
        });
    }

    simpleQuestion(title: string, message: string, value?: string, complete?: (reason: string) => void, cancel?: () => void) {
        const dialogData = new DialogQuestionSimpleModel(title, message, value);
        const dialogRef = this.dialog.open(DialogQuestionSimpleComponent, {
            data: dialogData
        });

        // Need to capture the value BEFORE the dialog closes
        dialogRef.beforeClosed().subscribe(dialogResult => {
            const el = <any>document.getElementById('izitoast--input');
            value = el.value;
        });

        dialogRef.afterClosed().subscribe(dialogResult => {
            if (dialogResult) {
                if (!!complete && typeof complete === 'function') {
                    complete(value);
                }
            } else {
                if (!!cancel && typeof cancel === 'function') {
                    cancel();
                }
            }
        });
    }

    appointment(appointment: AppointmentDto, navigate?: (appointmentId: number) => void) {
        const snackBarRef = this._snackBar.open('Upcoming Appointment', 'View', {
            horizontalPosition: 'right',
            verticalPosition: 'bottom',
            panelClass: ['snackbar-appointment']
        });
        if (!!navigate && typeof navigate === 'function') {
            snackBarRef.onAction().subscribe(() =>
                navigate(appointment.AppointmentID)
            );
        }
    }

    success(message: string, complete?: () => void, timeout?: number) {
        this._snackBar.open(message, 'OK', {
            duration: !!timeout ? timeout : 2000,
            panelClass: ['snackbar-success']
        });
        if (!!complete && typeof complete === 'function') {
            complete();
        }
    }

    warn(message: string, complete?: () => void, timeout?: number) {
        this._snackBar.open(message, 'Alert', {
            duration: !!timeout ? timeout : 2000,
            panelClass: ['snackbar-warn']
        });
        if (!!complete && typeof complete === 'function') {
            complete();
        }
    }

    error(message: string, timeout?: number) {
        this._snackBar.open(message, 'Error', {
            duration: !!timeout ? timeout : 2000,
            panelClass: ['snackbar-error']
        });
    }

    info(message: string, timeout?: number) {
        this._snackBar.open(message, 'Info', {
            duration: !!timeout ? timeout : 2000,
            panelClass: ['snackbar-information']
        });
    }
}
